import { MoveDeskDataV26 } from 'src/app/models-v26/move-desk-data-v26';
import { MoveDeskDueDates } from 'src/app/shared-components/allocation-wizard-modal-dialogs/move-wizard/init-step/due-date-step';
import { MoveInitStep } from 'src/app/shared-components/allocation-wizard-modal-dialogs/move-wizard/init-step/move-init-step';

export interface State {
  initStep: MoveInitStep;
  fromDeskStep: MoveDeskDataV26;
  dueDatesStep: MoveDeskDueDates;
  toDeskStep: MoveDeskDataV26;
  // addInfoStep: AdditionalInfo;
  // cancelRequest: CancelLicenseServicesRequest;
  // cancelLicenseServicesResponse: CancelLicenseServicesResponse;
  errorMessage: string;
}

export const initialState: State = {
  initStep: null,
  fromDeskStep: null,
  dueDatesStep: { moveDate: null },
  toDeskStep: null,
  // addInfoStep: null,
  // cancelRequest: null,
  // cancelLicenseServicesResponse: null,
  errorMessage: null,
};
